import { render, staticRenderFns } from "./CardSectionsBlockHeader.vue?vue&type=template&id=2e92dbc8&scoped=true"
import script from "./CardSectionsBlockHeader.vue?vue&type=script&lang=js"
export * from "./CardSectionsBlockHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e92dbc8",
  null
  
)

export default component.exports